export default __webpack_public_path__ + "static/media/penelopecrews.33a56a30.png";